import type { TxtModifier } from "@tiendanube/nube-sdk-types";

export type TextProps = {
	color?: string;
	background?: string;
	heading?: 1 | 2 | 3 | 4 | 5 | 6;
	modifiers?: TxtModifier[];
	inline?: boolean;
	children: string;
	__internalId: string;
	style?: React.CSSProperties;
};

export function Text(props: Readonly<TextProps>) {
	const {
		color,
		background,
		heading,
		modifiers = [],
		inline,
		children,
		style = {},
		__internalId,
	} = props;

	const customStyle: React.CSSProperties = {
		color,
		backgroundColor: background,
		fontWeight: modifiers.includes("bold") ? "bold" : undefined,
		fontStyle: modifiers.includes("italic") ? "italic" : undefined,
	};

	if (modifiers.includes("underline") && modifiers.includes("strike")) {
		style.textDecoration = "underline line-through";
	} else if (modifiers.includes("underline")) {
		style.textDecoration = "underline";
	} else if (modifiers.includes("strike")) {
		style.textDecoration = "line-through";
	}

	if (modifiers.includes("uppercase")) {
		style.textTransform = "uppercase";
	} else if (modifiers.includes("lowercase")) {
		style.textTransform = "lowercase";
	} else if (modifiers.includes("capitalize")) {
		style.textTransform = "capitalize";
	}

	if (inline) {
		return (
			<span
				className="nube-text"
				id={__internalId}
				style={{
					...customStyle,
					...style,
				}}
			>
				{children}
			</span>
		);
	}
	if (!heading) {
		return (
			<p
				className="nube-text"
				id={__internalId}
				style={{
					...customStyle,
					...style,
				}}
			>
				{children}
			</p>
		);
	}

	const HeadingComponent = `h${heading}` as keyof JSX.IntrinsicElements;
	return (
		<HeadingComponent
			className="nube-text"
			id={__internalId}
			style={{
				...customStyle,
				...style,
			}}
		>
			{children}
		</HeadingComponent>
	);
}
